import React from 'react';
import { useNavigate } from 'react-router-dom';
import { clsx } from 'clsx';
import { allProducts, type ProductConfig } from './productConfig';

interface ProductSwitcherProps {
  currentProduct: ProductConfig['id'];
}

export function ProductSwitcher({ currentProduct }: ProductSwitcherProps) {
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-1 bg-gray-100 dark:bg-gray-800 rounded-lg p-1">
      {allProducts.map((product) => {
        const Icon = product.logoIcon;
        const isCurrent = product.id === currentProduct;
        return (
          <button
            key={product.id}
            onClick={() => {
              if (isCurrent) return;
              if (product.externalUrl) {
                window.open(product.externalUrl, '_blank', 'noopener,noreferrer');
                return;
              }
              const firstRoute = Object.values(product.pageRouteMap)[0] || `/${product.id}`;
              navigate(firstRoute);
            }}
            title={product.externalUrl ? `${product.appName} (opens in new tab)` : product.appName}
            className={clsx(
              'flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-xs font-medium transition-all duration-150',
              isCurrent
                ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm'
                : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200'
            )}
          >
            <Icon className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">{product.id.charAt(0).toUpperCase() + product.id.slice(1)}</span>
          </button>
        );
      })}
    </div>
  );
}
